import { __read, __spreadArray } from 'tslib';
import * as React from 'react';

var AnalyticsContext = React.createContext({ pagesHistory: [] });
var AnalyticsTracking = function (_a) {
    var children = _a.children, router = _a.router;
    var _b = __read(React.useState([]), 2), pagesHistory = _b[0], setPagesHistory = _b[1];
    React.useEffect(function () {
        setPagesHistory(function (prev) { return __spreadArray([router.pathname], __read(prev), false); });
    }, [router.pathname]);
    return React.createElement(AnalyticsContext.Provider, { value: { pagesHistory: pagesHistory } }, children);
};
var usePageHistory = function () {
    var pagesHistory = React.useContext(AnalyticsContext).pagesHistory;
    var lastPage = pagesHistory.length > 0 ? pagesHistory[pagesHistory.length - 1] : undefined;
    return { lastPage: lastPage, pagesHistory: pagesHistory };
};

export { AnalyticsTracking, usePageHistory };
//# sourceMappingURL=AnalyticsTrackingContext.esm.js.map
